import * as LocalStorage from '../../../../infra/storage/local-storage'

import { Authority } from '../../../enums/authority.enum'

const billingGuard = async (to: any, from: any, next: any) => {
  if (to.meta.billing) {
    const hasPendingPayment = Boolean(LocalStorage.get('hasPendingPayment'))
    const authority = LocalStorage.get('authority')

    if (hasPendingPayment) {
      if (authority === Authority.DOCTOR) {
        next.redirect('/doctors/profile')
      } else if (authority === Authority.CONTRACTOR) {
        next.redirect('/contractors/profile')
      }
    } else {
      next()
    }
  } else {
    next()
  }
}

export default billingGuard
